import React, { useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";
import styles from "./HATVGarUplineImpact.module.scss";
import { useAppSelector } from "../../../../redux/hooks";
import { useTranslation } from "react-i18next";
import { useABOProfileNavigation } from "../../../../utils/common";
import { getAwardNameFromCode, getToTitleCase, getTrackingAwardColorFromCode, getTrackingAwardFromCode, getTrackingAwardIconFromCode } from "../../../../utils/awardIconMapping";
import { useLazyGetUserNameWithIDQuery } from "../../../../redux/services/hatvAboStatisticAPI";
import isNull from "lodash/isNull";
interface TableProps<T> {
  tableData: any;
  isLoading: boolean;
}

const HATVGarUplineImpact = <T,>({
  tableData,
  isLoading,
}: TableProps<T>) => {
  const { t } = useTranslation();

  const [tableUplineImpactData, setTableData] = useState<any>(tableData);
  const [userNameById, setUserNameById] = useState<string>('');
  const [
    getUserNameFromId,
    { isLoading: isGetUserNameLoading, isError: isGetUserNameError },
  ] = useLazyGetUserNameWithIDQuery();

  useEffect(() => {
    setTableData(tableData);
    if (!isNull(tableData) && tableData?.hatvAdmin?.userNativeId) {
      getUserNameFromId({
        nativeId: tableData?.hatvAdmin?.userNativeId
      }).then((userDetailsResp: any) => {
        setUserNameById(userDetailsResp?.data?.body?.fullName)
      })
    }
  }, [tableData]);

  const userDetails = useAppSelector((state: any) => state.userDetails.user);
  const [affiliateCode] = useState(userDetails?.affiliateCode || 0);
  const [aboNumber] = useState(userDetails?.aboNumber || 0);
  const [userAffiliateCode] = useState(userDetails?.userAffiliateCode || 0);
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const handleABOInfoClick = useABOProfileNavigation();
  return isLoading ? (
    <div className={styles.empty_state_document}>
      <div className={`table_no_data ${styles.empty_state_msg}`}>
        {t("loading")}
      </div>
    </div>
  ) : isEmpty(tableUplineImpactData) ? (
    <div className={styles.empty_state_document}>
      <div className={`table_no_data ${styles.empty_state_msg}`}>
        {t("no_info_available")}
      </div>
    </div>
  ) : (
    <section
      className={`table_container ${styles.table_container}`}
      data-testid="upline_impact_table_section_testID"
    >
      <div
        className={`${styles.table_wrapper}`}
      >
        <table className={styles.table}>
          <thead className={styles.tbl_header_wrapper}>
            <tr className={`tbl_header ${styles.tbl_header}`} >
              <th
                className={`header_cell_nohover ${styles.header_cell}`}
                data-testid="upline_iompact_table_column_header_testID"
              >
                {t("ABO_Info")}
              </th>

              <th
                className={`header_cell_nohover ${styles.header_cell}`}
              >
                {t("tracking_currentAward")}
              </th>
              <th
                className={`header_cell_nohover ${styles.header_cell}`}
              >
                {t("hatv_leader_details.case_evaluator")}
              </th>

            </tr>
          </thead>
          <tbody>
            {tableUplineImpactData &&
              <tr
                className={`tbl_data_row ${styles.tbl_data_row}`}
                data-testid="BCR_table_row_testID"
                style={{
                  backgroundColor: currentTheme === "light" ? "" : "#282828",
                }}
              >
                <td className={`data_cell ${styles.data_cell}`}>
                  <div className={`table_info ${styles.infoRightSection}`}
                    onClick={() =>
                      handleABOInfoClick(tableUplineImpactData?.aboNumber, tableUplineImpactData?.affiliateCode)
                    }
                  >
                    <label className={`labelInfo ${styles.labelInfo}`}>
                      {tableUplineImpactData?.name || "-"}
                    </label>
                    <label className={styles.labelInfoBottom}>
                      {tableUplineImpactData?.marketName && tableUplineImpactData?.marketCountryCode !== "" ? `${tableUplineImpactData?.aboNumber} | ${tableUplineImpactData?.marketName}` : tableUplineImpactData?.aboNumber}
                    </label>
                  </div>
                </td>
                <td className={`data_cell ${styles.data_cell}`}>
                  <div className={styles.award_wrapper}>
                    <span className={`award_name ${styles.award_name}`}>
                      {getAwardNameFromCode(tableUplineImpactData?.highestTrackingAward?.awardCode, t)}
                    </span>
                    {
                      <div
                        className={`${styles.awardIcon}`}
                        style={{
                          backgroundColor:
                            currentTheme === "light"
                              ? "#F4F4F4"
                              : "#1C1C1E",
                        }}
                      >
                        <span
                          className={`${styles.awardIconLeft}`}
                        >
                          {getTrackingAwardIconFromCode(
                            tableUplineImpactData?.highestTrackingAward?.awardTagCode,
                            currentTheme
                          )}
                        </span>
                        <span
                          className={`award_name ${styles.awardIconRight}`}
                          style={{
                            color: getTrackingAwardColorFromCode(
                              tableUplineImpactData?.highestTrackingAward?.awardTagCode,
                              currentTheme
                            ),
                          }}
                        >
                          {getTrackingAwardFromCode(
                            tableUplineImpactData?.highestTrackingAward?.awardTagCode,
                            t
                          )}
                        </span>
                      </div>
                    }
                  </div>
                  <div className={styles.award_wrapper}>
                    <span className={styles.award_name_full}>
                      {getAwardNameFromCode(tableUplineImpactData?.currentAward?.awardCode, t)}
                    </span>
                  </div>
                </td>
                <td className={`data_cell ${styles.data_cell}`}>
                  <span
                    className={styles.type_name}
                  >{getToTitleCase(userNameById) || "-"}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default HATVGarUplineImpact;
